export default {
	id: 'SIMPLE_PREMIUM_MALE_FALLBACK_TC_1M_44_1M_7_99',
	providers: {
		paltaMap: {
			USD: 'simple_premium_1m_44_1m_7_99_usd',
			EUR: 'simple_premium_1m_44_1m_7_99_eur',
			GBP: 'simple_premium_1m_44_1m_7_99_gbp',
			AUD: 'simple_premium_1m_72_1m_11_99_aud',
			CAD: 'simple_premium_1m_72_1m_11_99_cad',
			DKK: 'simple_premium_1m_379_1m_63_2_dkk',
			SEK: 'simple_premium_1m_579_1m_103_2_sek',
			NOK: 'simple_premium_1m_579_1m_103_2_nok',
			BRL: 'simple_premium_1m_179_1m_31_2_brl',
			MXN: 'simple_premium_1m_729_1m_127_2_mxn',
			TRY: 'simple_premium_1m_1429_1m_260_try',
			ARS: 'simple_premium_1m_58699_1m_10663_2_ars',
			COP: 'simple_premium_1m_175999_1m_31967_2_cop',
			CLP: 'simple_premium_1m_44000_1m_7992_clp',
		},
		primer: 'prd_kpa6dHjrPsvW',
	},
}
